var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgArrowDoubleHeadRight = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.78027 16.3999L10.3364 10.3485C10.3785 10.3027 10.4119 10.2484 10.4346 10.1886C10.4574 10.1288 10.4692 10.0647 10.4692 9.9999C10.4692 9.93515 10.4574 9.87103 10.4346 9.81122C10.4119 9.75141 10.3785 9.69708 10.3364 9.65135L4.78027 3.5999",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5801 16.3999L16.1362 10.3485C16.1783 10.3027 16.2117 10.2484 16.2345 10.1886C16.2572 10.1288 16.269 10.0647 16.269 9.9999C16.269 9.93515 16.2572 9.87103 16.2345 9.81122C16.2117 9.75141 16.1783 9.69708 16.1362 9.65135L10.5801 3.5999",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowDoubleHeadRight, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrowDoubleHeadRight.aaa60eb7.svg";
export { ForwardRef as ReactComponent };